import { render, staticRenderFns } from "./NewBuildingForm.vue?vue&type=template&id=10f874f6&scoped=true&"
import script from "./NewBuildingForm.vue?vue&type=script&lang=js&"
export * from "./NewBuildingForm.vue?vue&type=script&lang=js&"
import style0 from "./NewBuildingForm.vue?vue&type=style&index=0&id=10f874f6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f874f6",
  null
  
)

export default component.exports